import { all, call, fork, put, takeEvery, select } from "redux-saga/effects";

import { driverSelectSuccess } from "./actions";
import { authApiAccessCheck } from "../auth/actions";

import { DriverSelectBySubscriber } from "../../api-tasks/drivers";
import { DRIVER_SELECT_REQUEST } from "../actions";

function* selectDrivers({payload}) {
    
    const state = yield select();
    const { history } = payload;
    try {
      const authUser = state.authUser;
      const user = authUser.user;
  
      const resultSet = yield call(DriverSelectBySubscriber, user.userToken);
      
      if (resultSet) {
        if (Array.isArray(resultSet)) {
          yield put(driverSelectSuccess(resultSet));
        } else { 
            yield put(authApiAccessCheck(history, resultSet));
        }
      }
    } catch (error) {
      console.log("error vehicle saga 1 :", error);
    }
  }


  export function* watchSelectAllRequest() {
    yield takeEvery(DRIVER_SELECT_REQUEST, selectDrivers);
  }

  export default function* rootSaga() {
    yield all([fork(watchSelectAllRequest)]);
  }
